import { toRefs, ref, computed, watch } from 'vue';
import Input from '../input/component-lib.esm.js';
import { useModel } from '../../compositions/component-lib.esm13.js';

//
var script = {
  name: 'OtpInput',
  components: {
    Input
  },
  props: {
    value: {
      type: String,
      default: null
    },
    length: {
      type: [String, Number],
      default: 4
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    readonly: Boolean
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value
    } = toRefs(props);
    const internalValue = useModel(value, val => emit('input', val));
    const otp = ref(null);
    const inputs = ref([]);
    const isFocused = ref(false);
    const hasWentNext = ref(false);
    const placeholderInternal = computed(() => {
      var _props$placeholder;
      return ((_props$placeholder = props.placeholder) === null || _props$placeholder === void 0 ? void 0 : _props$placeholder.split('')) || [];
    });
    watch(otp, val => {
      internalValue.value = val === null || val === void 0 ? void 0 : val.join('');
    });
    watch(internalValue, val => {
      otp.value = (val === null || val === void 0 ? void 0 : val.split('')) || [];
    }, {
      immediate: true
    });
    function handleInput(e, index) {
      e.stopPropagation();
      hasWentNext.value = false;
      const maxCursor = +props.length - 1;
      const target = e.target;
      // If type is number, remove any non numeric characters
      // else just return value
      const value = props.type === 'number' ? target.value.replace(/\D/g, '') : target.value;
      target.value = value;
      const inputDataArray = (value === null || value === void 0 ? void 0 : value.split('')) || [];
      const newOtp = [...otp.value];
      for (let i = 0; i < inputDataArray.length; i++) {
        const appIndex = index + i;
        if (appIndex > maxCursor) {
          break;
        }
        newOtp[appIndex] = inputDataArray[i].toString();
      }
      if (!inputDataArray.length) {
        newOtp.splice(index, 1);
      }
      otp.value = newOtp;
      if (index + inputDataArray.length >= +props.length) {
        onCompleted();
        clearFocus(index);
      } else if (inputDataArray.length) {
        changeFocus(index + inputDataArray.length);
      }
    }
    function clearFocus(index) {
      const input = inputs.value[index].input;
      input.blur();
    }
    function changeFocus(index) {
      handleFocus(null, index || 0);
    }
    function handleKeyDown(e) {
      emit('keydown', e);
    }
    function handleKeyUp(e, index) {
      const eventKey = e.key;
      // Fix weird bug where it would go back two inputs
      if (hasWentNext.value) {
        setTimeout(() => {
          hasWentNext.value = false;
        }, 100);
        return;
      }
      if (['Tab', 'Shift', 'Meta', 'Control', 'Alt'].includes(eventKey)) {
        return;
      }
      if (['Delete'].includes(eventKey)) {
        return;
      }
      if (eventKey === 'ArrowLeft' || eventKey === 'Backspace' && !otp.value[index]) {
        hasWentNext.value = true;
        return index > 0 && changeFocus(index - 1);
      }
      if (eventKey === 'ArrowRight') {
        hasWentNext.value = true;
        return index + 1 < +props.length && changeFocus(index + 1);
      }
    }
    function handleFocus(e, otpIndex) {
      var _inputs$value$otpInde;
      e === null || e === void 0 ? void 0 : e.preventDefault();
      e === null || e === void 0 ? void 0 : e.stopPropagation();
      const ref = (_inputs$value$otpInde = inputs.value[otpIndex]) === null || _inputs$value$otpInde === void 0 ? void 0 : _inputs$value$otpInde.input;
      if (!ref) return;
      if (document.activeElement !== ref) {
        ref.focus();
        return ref.select();
      }
      if (!isFocused.value) {
        isFocused.value = true;
        ref.select();
        if (e) emit('focus', e);
      }
    }
    function handleBlur(e) {
      isFocused.value = false;
      if (e) emit('blur', e);
    }
    function onCompleted() {
      const rsp = otp.value.join('');
      if (rsp.length === +props.length) {
        emit('finish', rsp);
      }
    }
    function focus() {
      handleFocus(null, 0);
    }
    return {
      inputs,
      otp,
      isFocused,
      handleInput,
      handleKeyDown,
      handleKeyUp,
      handleFocus,
      handleBlur,
      focus,
      placeholderInternal
    };
  }
};
export { script as default };